import {
  MaterialSymbol,
  type IconKey,
  type MaterialSymbolProps,
} from 'react-material-symbol-icons';

type Props = Omit<MaterialSymbolProps, 'icon'> & {
  icon: string;
};

const DirectusIcon = ({ icon, ...rest }: Props) => {
  return <MaterialSymbol icon={icon as IconKey} {...rest} />;
};

export default DirectusIcon;
